// removed by extract-text-webpack-plugin
module.exports = {"nf-edit-user":"nf-edit-user","nf-edit-user__header":"nf-edit-user__header","nf-edit-user__subheader":"nf-edit-user__subheader"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Modals/EditUser/EditUser.scss
// module id = 5362
// module chunks = 1